// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"headerWrapper--1vv8q","inputWrapper":"inputWrapper--1SHIS","input":"input--2oq6J"};